import {useState,useEffect} from "react";
import BreadCrumb from "../Controls/BreadCrumb";
import UserData from "../Controls/UserData";
import "../../style/scss/Recruit.scss";
import EmployerRecruitListItem from "../ListItems/EmployerRecruitListItem";
import Help from "../Controls/Help";
import API from "@src/API.js";

export default function Recruit(props) {
   const [recruitData, Update] = useState(UserData.RecruitData());
   const [loading, setLoading] = useState(false);
   useEffect(() => {
      let cancelled = false;
      const load = async () => {
         if (recruitData && recruitData.Employers && recruitData.Employers.length > 0)
            return;
         setLoading(true);
         try {
            const resp = await API.getAsync("/RecruitingData");
            if (cancelled) return;
            if (resp && resp.ok && resp.jsonData) {
               window.sessionStorage.setItem("RecruitData", JSON.stringify(resp.jsonData));
               Update(resp.jsonData);
            }
         } catch (err) {
            console.error("Failed to load recruiting data", err);
         } finally {
            if (!cancelled) setLoading(false);
         }
      };
      load();
      return () => { cancelled = true; };
   }, [recruitData]);
   const breadcrumb = [{ label: "Hiring", route: "/recruit" }];
   return (
      <div className="pagebody RecruitDash">
         <BreadCrumb props={breadcrumb} />
         <div className="tabbody">
            <span className="pageTitle">Recruiting Dashboard</span>
            <Help id="2142" />
            {loading ? <div className="loading">Loading employers…</div> : null}
            <ul className="recruitList">
               <div>
                  {recruitData && recruitData.Employers
                     ? recruitData.Employers.map((e) => (
                          <li key={e.id || e.ID}>
                             <EmployerRecruitListItem employer={e} data={recruitData} breadcrumb={breadcrumb} />
                          </li>
                       ))
                     : ""}
               </div>
            </ul>
         </div>
      </div>
   );
}
